// IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий) — чистая логика стрелки «Back to the previous chart»
// островка кнопок графика (AttrChart, .corner-island-tr): каждый «Split the series» формы / вкладки расшифровки (chartDrillMixin.chartDrill_split)
// кладёт в стек виджета (WIDGET._chartSplitBack, в памяти до перезагрузки) снимок doc.viewList и карты откатов WIDGET._chartDrillUndo ДО разбиения;
// клик по стрелке — шаг назад на один уровень (снимок возвращается в запись, запись помечается изменённой, график перечитывается), на последнем
// шаге стек пуст — стрелка исчезает. «Undo split» формы для меры M — уровни M из стека убираются, в более новых снимках разбиение M тоже откатывается.
// Стек привязан к записи (id): другая запись виджета — стрелки нет. Флаг fe.ux.chartSplitBack (дефолт ВКЛ). Юнит — tests/unit/chartSplitBack.test.mjs
import { drillSplitUndo, drillSplitRemove } from './chartDrill.js'

export const CHART_SPLIT_BACK_FLAG = 'fe.ux.chartSplitBack'   // IE 2026 10 31 / ODOO-347310
export const CHART_SPLIT_BACK_MAX = 20   // глубина стека (старые уровни отбрасываются)

export function chartSplitBack_on(setting) {   // IE 2026 10 31 / ODOO-347310: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CHART_SPLIT_BACK_FLAG, true) !== false : true } catch (e) { return true }
}

const _clone = (v) => (v === undefined ? undefined : JSON.parse(JSON.stringify(v)))

// ключ записи виджета: стек чужой записи не показывается
export function splitBackRecKey(rec) {
    if (!rec || typeof rec !== 'object') return null
    const id = rec.id !== undefined && rec.id !== null ? rec.id : (rec.doc && rec.doc.id)
    return id === undefined || id === null ? '' : String(id)
}

// уровни стека для этой записи ([] — нет / чужая запись)
export function splitBackSteps(state, recKey) {
    if (!state || !Array.isArray(state.steps) || state.recKey !== recKey) return []
    return state.steps
}

export function splitBackCan(state, recKey) { return splitBackSteps(state, recKey).length > 0 }

// снимок ДО разбиения: { viewList, undo } (копии; живые данные записи не трогаются)
export function splitBackSnapshot(doc, undoMap) {
    return { viewList: _clone(Array.isArray(doc && doc.viewList) ? doc.viewList : []), undo: _clone(undoMap || {}) || {} }
}

// положить уровень: возвращает новое состояние стека
export function splitBackPush(state, recKey, snap, meta = {}) {
    const steps = splitBackSteps(state, recKey).slice()
    steps.push({ viewList: snap.viewList, undo: snap.undo, measure: meta.measure || null, dim: meta.dim || null })
    while (steps.length > CHART_SPLIT_BACK_MAX) steps.shift()
    return { recKey, steps }
}

// шаг назад: снимок верхнего уровня возвращается в doc.viewList (на месте), результат — { state, undo } (undo — карта откатов того уровня)
// либо null (назад некуда)
export function splitBackPop(state, recKey, doc) {
    const steps = splitBackSteps(state, recKey).slice()
    if (!steps.length || !doc) return null
    const top = steps.pop()
    const vl = Array.isArray(doc.viewList) ? doc.viewList : (doc.viewList = [])
    vl.splice(0, vl.length, ..._clone(top.viewList))
    return { state: { recKey, steps }, undo: _clone(top.undo) || {} }
}

// «Undo split» формы для меры measure (undo — её снимок из WIDGET._chartDrillUndo до отката или null — разрез был сохранён в записи):
// уровни разбиения этой меры убираются, в более новых снимках её разбиение откатывается тем же снимком, из карт откатов мера убирается
export function splitBackAfterUnsplit(state, recKey, measure, undo) {
    const steps = splitBackSteps(state, recKey)
    if (!steps.length) return state
    const out = []
    let seen = false
    for (const s of steps) {
        if (s.measure === measure) { seen = true; continue }
        const st = { ...s, viewList: _clone(s.viewList), undo: { ...(s.undo || {}) } }
        if (seen || (st.undo && st.undo[measure])) {
            const d = { viewList: st.viewList }
            if (undo) drillSplitUndo(d, undo); else drillSplitRemove(d, measure)
            st.viewList = d.viewList
        }
        delete st.undo[measure]
        out.push(st)
    }
    return { recKey, steps: out }
}
